<template>
  <div>
    <v-container class="pa-0" fluid v-if="$store.getters['merchant/theme'].collection_banner">
      <CatalogueBanner/>
    </v-container>
    <v-container class="mt-6" v-if="filter_position === 'top'">
      <v-card class="pa-0 my-4" outlined>
        <v-card class="pa-6" color="grey lighten-4" outlined>
          <FilterItemsTop @close="views = { ...views, search: false }"/>
        </v-card>
      </v-card>
      <ProductsList :items="items"/>
    </v-container>
    <v-container class="mt-6" v-else>
      <v-row>
        <v-col cols="3">
          <div v-if="filter_position === 'side-short'">
            <v-card elevation="0" outlined>
              <v-card-text class="py-6 px-6">
                <FilterItemsSide @close="views = { ...views, search: false }"/>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="filter_position === 'side-long'" class="py-3 pr-4" style="border-right: 1px solid rgba(0, 0, 0, .1)">
            <FilterItemsSideLong @close="views = { ...views, search: false }"/>
          </div>
        </v-col>
        <v-col cols="9">
          <ProductsList :items="items"/>
        </v-col>
      </v-row>
    </v-container>
    <Footer/>
  </div>
</template>

<script>
import catalogue from "../../mixins/catalogue";
import FilterItemsSide from "../FilterItemsSide";
import ProductsList from "./ProductsList";
import Footer from "../templates/default/Footer";
import FilterItemsTop from "../FilterItemsTop";
import FilterItemsSideLong from "../FilterItemsSideLong";
import CatalogueBanner from "./CatalogueBanner";

export default {
  name: "CatalogueDesktop",
  mixins: [catalogue],
  components: { CatalogueBanner, FilterItemsSideLong, FilterItemsTop, Footer, FilterItemsSide, ProductsList },
  computed: {
    loading() {
      return this.$store.state.catalogue.loading;
    },
    fetching() {
      return this.$store.state.catalogue.fetching;
    },
    filter_position() {
      return this.$store.getters['merchant/theme'].filter_position;
    }
  }
}
</script>
